export default "__VITE_ASSET__421f5d3e__"